export default "__VITE_ASSET__239e1787__"